import createRestfulModule from './restful-module'
import { actionClient } from '@/api'
export default createRestfulModule({

  state: {
    path: 'video', // 资源路径
    defaultRels: ['videoCate'], // 默认需要的关联数据

  },

  actions: {
    async syncVideo() {
      return await actionClient.get('/video-sync')
    }
  }

})
